/* @flow */

const fecharSidebarParaCaber = () => {
    const sidebarToggler = global.m_aside_left_minimize_toggle;

    if (
        window.innerWidth < 1440
        && global.mUtil.isInResponsiveRange('desktop')
        && !sidebarToggler.classList.contains('m-brand__toggler--active')
    ) {
        sidebarToggler.click();
    }
};

export default fecharSidebarParaCaber;
